import "./NameCodeFile.scss";

interface NameCodeFileProps {
  file: any;
}
const NameCodeFile: React.FC<NameCodeFileProps> = ({ file }) => {
  return (
    <div className="template-code-file">
      <div className="template-code-file__files">
        <div key={file?.id}>
          <span>{file?.name}</span>
          <svg
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.34771 3.71879L9.06021 0.00628662L10.1207 1.06679L6.40821 4.77929L10.1207 8.49179L9.06021 9.55229L5.34771 5.83979L1.63521 9.55229L0.574707 8.49179L4.28721 4.77929L0.574707 1.06679L1.63521 0.00628662L5.34771 3.71879Z"
              fill="#607B96"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
export default NameCodeFile;
